import { createContext } from 'react';
import {
	IRestaurantAndroidWatchesMessagesData,
	TAndroidWatchesImportantMessages,
	TAndroidWatchesInformationMessages,
} from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';
export interface IAndroidWatchesMessagesData {
	restaurantID: string;
	data: IRestaurantAndroidWatchesMessagesData;
}

export interface IAndroidWatchesFormState {
	importantMessages: TAndroidWatchesImportantMessages[];
	informationMessages: TAndroidWatchesInformationMessages[];
	dataForSubmit: Nullable<IAndroidWatchesMessagesData>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const androidWatchesFormInitialState: IAndroidWatchesFormState = {
	importantMessages: [],
	informationMessages: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IAndroidWatchesFormContext extends IAndroidWatchesFormState {
	setImportantMessages(value: TAndroidWatchesImportantMessages[]): void;
	setInformationMessages(value: TAndroidWatchesInformationMessages[]): void;
	setDataForSubmit(value: IAndroidWatchesMessagesData): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const AndroidWatchesFormContext = createContext<IAndroidWatchesFormContext>({
	setImportantMessages: () => undefined,
	setInformationMessages: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...androidWatchesFormInitialState,
});
